import * as React from 'react';
import { connect, MapStateToPropsParam } from 'react-redux';
import Store from '../../common/models/Store';
import { CountryCode } from '../../common/models/Store/CountryCode';

export type BuildUrlWithCountry = (route?: string) => string;

interface WrappedComponentProps {
  buildUrlWithCountry: BuildUrlWithCountry;
}

interface RoutesHocProps {
  countryCode: CountryCode;
}

// T should be type of WrappedComponent props without WrappedComponentProps fields
const withCountryCode = <T extends {}>(
  WrappedComponent: React.ComponentType<T & WrappedComponentProps>,
): React.ComponentType<T> => {
  const mapStateToProps: MapStateToPropsParam<RoutesHocProps, null, Store> = ({
    countryCode,
  }: Store): RoutesHocProps => ({
    countryCode,
  });

  const HocComponent: React.FC<T & RoutesHocProps> = props => {
    const buildUrlWithCountry: BuildUrlWithCountry = (route = '') => {
      const { countryCode } = props;
      return `/${countryCode}${route}`;
    };

    return <WrappedComponent buildUrlWithCountry={buildUrlWithCountry} {...props} />;
  };

  return connect(mapStateToProps)(HocComponent as React.ComponentType);
};

export default withCountryCode;
